import React, { Component } from 'react';
import Style from './index.less';
import Checkbox from '@tencent/dui/lib/components/Checkbox';

export default class LiveJoinMeetingDialog extends Component {


    constructor(props) {
        super(props);

        this.state = {
            mute: false,
        };  
    }

    onCheckChanged = (value) => {
        this.setState({ 
            mute: value,
        });
    }

    onClickClose = () => {
        let state = {
            action: 'close-showTip',
        }
        this.props.handleCloseDialog && this.props.handleCloseDialog(state);
    }

    onJoinMeeting = () => {
        let state = {
            action: 'join-Meeting',
            mute: this.state.mute,
        }
        this.props.handleCloseDialog && this.props.handleCloseDialog(state);
    }

    render() {


        return (
            <div className={'dialog-wrapper-joinMeeting ' + Style['dialog-wrapper-joinMeeting'] + ' bubble-joinMeeting ' + Style['bubble-joinMeeting'] + ' top-joinMeeting ' + Style['top-joinMeeting'] + ' bubble-dark-joinMeeting ' + Style['bubble-dark-joinMeeting']}>
                <button aria-label="Close" className={'modal-close-joinMeeting ' + Style['modal-close-joinMeeting']} onClick={this.onClickClose}><span className={'modal-close-x-joinMeeting ' + Style['modal-close-x-joinMeeting']}></span></button>
                <div className={'modal-content-joinMeeting ' + Style['modal-content-joinMeeting']}>
                    <h1>邀请你加入语音讨论</h1>
                    <div className={'img-wrapper-joinMeeting ' + Style['img-wrapper-joinMeeting'] + ' icon-guide-2x-joinMeeting ' + Style['icon-guide-2x-joinMeeting']}></div>
                    <div className={'div-check-joinMeeting ' + Style['div-check-joinMeeting']}>
                        <Checkbox checked={this.state.mute} onChange={this.onCheckChanged} style={{ fontSize: '16px', }}>静音入会</Checkbox>
                    </div>
                    <div>
                        <button className={'sm-button-joinMeeting ' + Style['sm-button-joinMeeting']} type="black" onClick={this.onJoinMeeting}>进入语音讨论</button>
                    </div>
                    <p className={'bottom-tip-joinMeeting ' + Style['bottom-tip-joinMeeting']}>Powered by 腾讯会议
                    </p>
                </div>
            </div>
        );
    }
}